var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComputing = function SvgComputing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75,
    d: "M10.984 7.5v-3c0-2.5-1-3.5-3.5-3.5h-3c-2.5 0-3.5 1-3.5 3.5v3c0 2.5 1 3.5 3.5 3.5h3c2.5 0 3.5-1 3.5-3.5M9.86 1.625 1.635 9.85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    d: "M8.03 9V6.5M9.25 7.75h-2.5M5.25 3.75h-2.5"
  })));
};
export default SvgComputing;